export const MONITOR_BUILD_PROGRESS = `
subscription monitorBuildProgress($build: ID!) {
  monitorBuildProgress(build: $build)
}
`;
export const MONITOR_LOG_SUBSCRIPTION = `
subscription monitorLog($pipelineRef: String!, $lastId: String) {
    monitorLog(pipelineRef: $pipelineRef, lastId: $lastId){id, log, status, task, tasks}
}
`;
